module.exports = __webpack_public_path__ + "img/404-illustration.405b8465.svg";